<template>
  <div>
    <b-row class="mt-1">
      <b-col v-if="!isLightMode">
        <c-tel-input v-model="authentication.phone" class="m-0" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="email"
          lableText="Email *"
          v-model="authentication.email"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="username"
          lableText="User Name *"
          v-model="authentication.userName"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Password *"
          v-model="authentication.password"
        />
        <small
          id="passwordHelp"
          style="font-size: 13px"
          class="form-text text-muted mx-1"
          v-if="authentication.password"
        >
          <span
            :class="has_minimum_lenth ? 'has_required' : ''"
            class="validate-error"
            >Password should contain atleast 8 characters ,</span
          >
          <span
            :class="has_number ? 'has_required' : ''"
            class="validate-error"
          >
            alphanumeric ,<br
          /></span>
          <span
            :class="has_uppercase ? 'has_required' : ''"
            class="validate-error"
          >
            first letter of the password should be capital and</span
          >
          <span
            :class="has_special ? 'has_required' : ''"
            class="validate-error"
          >
            one special <br />
            character (@, $, !, &, etc)</span
          >
        </small>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="!isLightMode">
        <eb-select
          :label="'text'"
          placeholder="Security Question *"
          :options="securityQuestions"
          v-model="authentication.securityQuestions.question"
        ></eb-select>
      </b-col>
    </b-row>

    <b-row class="sqanswer">
      <b-col v-if="!isLightMode">
        <c-input
          inputType="text"
          inputId="sqa"
          lableText="Security Question Answers *"
          v-model="authentication.securityQuestions.answer"
        />
      </b-col>
    </b-row>
    <slot
      name="footer-button"
      :data="{ ...authentication, passwordValid }"
    ></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "Authentication",
  props: ["officeData", "isLightMode"],

  data() {
    return {
      has_minimum_lenth: false,
      has_number: false,
      has_uppercase: false,
      has_special: false,
      securityQuestions: [
        {
          text: "what is your mother maiden name",
          value: "what is your mother maiden name",
        },
        {
          text: "what is your first school",
          value: "what is your first school",
        },
        { text: "your first car model", value: "your first car model" },
      ],
      authentication: {
        phone: "",
        email: "",
        userName: "",
        password: "",
        securityQuestions: {
          question: {},
          answer: "",
        },
      },
    };
  },

  mounted() {
    if (this.isLightMode) {
      this.authentication.securityQuestions.question =
        this.securityQuestions[0];
      this.authentication.securityQuestions.answer = "NA";
    }
  },
  watch: {
    officeData: function (officeData) {
      if (this.isLightMode) {
        this.authentication.userName = officeData.officeName;
        this.authentication.phone = officeData.phone[0].number;
        this.authentication.email = officeData.email[0].mailId;
      }
    },
    "authentication.password"() {
      this.has_minimum_lenth = this.authentication.password.length > 7;
      this.has_number = /\d/.test(this.authentication.password);
      this.has_uppercase = /[A-Z]/.test(
        this.authentication.password.split("")[0]
      );
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(
        this.authentication.password
      );
    },
  },
  computed: {
    passwordValid() {
      return (
        this.has_minimum_lenth &&
        this.has_number &&
        this.has_uppercase &&
        this.has_special
      );
    },
  },

  components: {
    cInput,
    cTelInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}

.has_required {
  visibility: hidden;
  color: red;
}

.validate-error {
  color: red;
}
</style>
